module.exports = "\n.logo-elzevir {\n    font-family: 'Elzevir', sans-serif;\n    color: #545454;\n    font-size: 3em;\n}\n\n.form-signin {\n  /*margin-top: 100px;*/\n}\n\n/*.snackbar-success {\n  background-color: #00ff7f !important;\n}*/\n\n::ng-deep .mat-tab-label {\n  min-width: 150px !important;\n  max-width: 150px !important;\n}\n\n.full-width {\n    display: block;\n    margin: 0 auto;\n    width: 80%;\n    max-width: 300px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main